import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const benefits = ['Tu perro va a dejar de rascarse y lamerse las patas — atacando el problema desde la raíz', 'Vas a saber exactamente qué está comiendo y por qué le hace bien', 'Vas a hacer el cambio sin miedo — cada paso explicado para que no te equivoques', 'Vas a ser la dueña que sabe cómo cuidar a su perro de verdad', 'Vas a dejar de sentir culpa — porque por fin vas a saber que estás haciendo lo correcto'];
export function TransformationSection() {
  return <section className="py-8 md:py-10 px-4 bg-cream" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-204">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight text-[#2D5016]" data-id="element-205">
            La solucion es mas simple de lo que crees
          </h2>

          <div className="space-y-5 max-w-md mx-auto text-left" data-id="element-206">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center" data-id="element-207">
                <CheckCircle2Icon className="w-6 h-6 text-primary flex-shrink-0 mr-4" data-id="element-208" />
                <span className="text-lg text-gray-800" data-id="element-209">{benefit}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}